import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { HiOutlineMenuAlt4, HiX } from "react-icons/hi";
import { FiArrowRight } from "react-icons/fi";
import brand from "../content/brand";

const links = [
  { to: "/", label: "Home", end: true },
  { to: "/capabilities", label: "Capabilities" },
  { to: "/approach", label: "Approach" },
  { to: "/studio", label: "Studio" },
  { to: "/contact", label: "Contact" }
];

const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="masthead">
      <div className="shell row">
        <Link to="/" className="brand" onClick={() => setOpen(false)} aria-label={brand.name}>
          <img src="/brand/cmv-logo.png" alt={brand.name} className="logo" />
        </Link>

        <nav>
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} className={({ isActive }) => isActive ? "is-on" : ""}>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="extras">
          <Link to="/contact" className="btn btn--cobalt">
            Start a brief <FiArrowRight />
          </Link>
          <button className="toggle" aria-label="Toggle menu" onClick={() => setOpen((v) => !v)}>
            {open ? <HiX /> : <HiOutlineMenuAlt4 />}
          </button>
        </div>
      </div>

      {open && (
        <div className="mobile-nav">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} onClick={() => setOpen(false)}>
              {l.label}
            </NavLink>
          ))}
          <Link to="/contact" className="btn btn--cobalt" onClick={() => setOpen(false)} style={{ marginTop: "1rem", width: "100%", justifyContent: "center" }}>
            Start a brief <FiArrowRight />
          </Link>
        </div>
      )}
    </header>
  );
};

export default Header;
